<template>
    <div class="step-template">
        <div :class="`text-wrapper no-app step-${ this.appStep }`">
                <h1>Vitadio motiviert zur Änderung des&nbsp;Lebensstils</h1>
                
                <figure class="diagram">
                    <picture>
                        <source media="(min-width: 1800px)" src="/imgs/web/webdemo-doctors/app_step_0_diagram@2x.webp">
                        <img src="/imgs/web/webdemo-doctors/app_step_0_diagram.webp" srcset="/imgs/web/webdemo-doctors/app_step_0_diagram.webp 1x, /imgs/web/webdemo-doctors/app_step_0_diagram@2x.webp 2x">
                    </picture>
                    
                    <v-button
                        variant="primary"
                        color="green"
                        label="Weiter"
                        size="lg"
                        @onClick="actualStep()" 
                    />
                </figure>

                
        </div>

        <figure class="screen">
                    <picture>
                        <source media="(min-width: 1800px)" src="`/imgs/web/webdemo-doctors/app_step_0@2x.webp`">
                        <img src="/imgs/web/webdemo-doctors/app_step_0.webp" srcset="/imgs/web/webdemo-doctors/app_step_0.webp 1x, /imgs/web/webdemo-doctors/app_step_0@2x.webp 2x">
                    </picture>
                </figure>
    </div>
</template>

<script>
export default {

    props: {},
    data(){
        return {
            appStep: 0
        }
    },

    methods: {
        actualStep() {
            this.$emit('app-step', ++this.appStep)
        }
    }
}

</script>

